module.exports = __webpack_public_path__ + "static/media/user.298b1e63.svg";